import Image from 'next/image'
import styles from '~/styles/_pricing.module.scss'
import { ActionButton } from './ActionButton'

export const FirstViewSection = () => (
  <section className={`bg-white ${styles['first-view']}`}>
    <div className="h-100 d-flex flex-column-reverse flex-md-row align-items-center justify-content-end justify-content-md-center mx-auto">
      <div className="text-nowrap text-center text-md-start">
        <h1>
          <div className={styles['first-view-description']}>
            数学の情報共有をもっと円滑に
          </div>
          <div className={styles['first-view-title']}>
            Mathlog <br />
            プレミアムプラン
          </div>
        </h1>
        <ActionButton
          location="top"
          variant="light"
          className={`${styles['pricing-btn']} text-primary d-none d-lg-inline-block`}
        />
      </div>
      <div className={styles['first-view-image']}>
        <Image
          width={643}
          height={515}
          layout="responsive"
          alt="数学の情報共有をもっと円滑にMathlogプレミアムプランのイラスト"
          src="/images/pricing_first_view_illust.png"
        />
      </div>
    </div>
  </section>
)
